import React from 'react';
import {OverlayTrigger, Tooltip} from "react-bootstrap";

interface Props {
  label: string;
  faIcon: string
  onClick: () => void;
  placement?: string;
  disabled?: boolean;
}

function ActionIcon({label, onClick, faIcon, placement = 'top', disabled = false}: Props) {
  return (
    <OverlayTrigger
      overlay={
        <Tooltip>
          <span>{label}</span>
        </Tooltip>
      }
      // @ts-ignore
      placement={placement}
    >
      <i
        style={{margin: 5, cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.4 : 1}}
        className={faIcon}
        onClick={disabled ? undefined : onClick}
      ></i>
    </OverlayTrigger>
  );
}

export default ActionIcon;